export default __webpack_public_path__ + "static/media/about2.2b2a9aff.png";